module.exports = __webpack_public_path__ + "img/font-shadow-white-color.a9211a5b.svg";